import ngAnnotate from '../ngAnnotate.macro';

const announcementRoutes = $routeProvider => {
  /**
   * Angular route configuration - Conditionally used based on 'removeAngularFeature' flag
   *
   * When removeAngularFeature is OFF: This Angular route handles all /announcement/* paths
   * When removeAngularFeature is ON: React Router (Router/index.tsx) handles these paths:
   *   - /announcement/list -> AnnouncementListPage
   *   - /announcement/new -> AnnouncementEditPage
   *   - /announcement/:announcementId/edit -> AnnouncementEditPage
   *
   * Note: Feature flags are not loaded at config time, so this route is always registered.
   * React Router takes priority and matches first, so when the flag is ON, React routes
   * are used and this Angular route is never reached for those specific paths.
   */
  $routeProvider.when('/announcement/:rest*?', {
    template: '<bb-announcement-router />',
    reloadOnUrl: false,
  });
};

ngAnnotate(announcementRoutes);

export default announcementRoutes;
